export const Icon = ({
  name,
  size,
  color,
  fill = false,
  onClick,
  elementAttributes,
}) => (
  <span
    {...elementAttributes}
    className={`material-symbols-outlined ${elementAttributes?.className ?? ''}`}
    onClick={onClick}
    style={{
      fontSize: `${size}px`,
      color,
      fontVariationSettings: `${fill ? "'FILL' 1" : '0'}`,
      backgroundColor: 'transparent',
      ...elementAttributes?.style,
    }}
  >
    {name}
  </span>
);
